<template>
	<Datepicker
		:key="elKey"
		input-class="date_int"
		:typeable="true"
		:language="en"
		:value="value"
		format="MM-dd-yyyy"
		:highlighted="highlighted"
		@input="updateValue"
		@changedMonth="changedMonth"
		:disabled="disabled"
		:disabled-dates="disableDates"
	></Datepicker>
</template>

<script>
//import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { en } from 'vuejs-datepicker/dist/locale';
// import '@/assets/css/layout.css';
import { toText } from '@/utils/date.js';

export default {
	props: ['value', 'disabled', 'disable_past', 'disable_future'],
	watch: {
		value: {
			handler() {
				if (this.value !== this.displayValue) {
					this.elKey++;

					this.$nextTick(() => {
						let date_picker_el = this.$el.querySelectorAll("input[type='text'], input[type='number']");
						date_picker_el.forEach(el => el.addEventListener('click', e => e.target.select()));
					});
				}
			},
		},
	},
	name: 'customDatePicker',
	data: function() {
		return {
			en: en,
			highlighted: {
				dates: [new Date()],
			},
			disableDates: {},
			displayValue: null,
			elKey: 0,
		};
	},
	components: {
		Datepicker,
	},
	methods: {
		updateValue: function(event) {
			this.$emit('input', this.valueFormat(event));
		},
		valueFormat(date) {
			if (date == null) return null;
			//console.log(date);
			//console.log(toText(date, '-'));

			date = toText(date, '-');
			this.displayValue = date;
			return date;
			// console.log(date);
			// var inputDate = new Date(date);
			// console.log(inputDate);
			// console.log(moment(inputDate).format('MM-DD-yyyy'));
			// return (
			// 	moment(inputDate)
			// 		//.tz(this.$session.get('time_zone'))
			// 		.format('MM-DD-yyyy')
			// );
		},
		changedMonth: function(event) {
			//console.log('changed...', event);
			var date;
			if (event.timestamp) date = event.timestamp;
			else date = event;
			//this.$emit('input', this.valueFormat(event));
			this.$emit('input', this.valueFormat(date));
		},
		getUSHolidays(year) {
			const holidays = [];
			const findNthDay = (year, month, dayOfWeek, n) => {
				const date = new Date(year, month, 1);
				let count = 0;
				while (count < n) {
					if (date.getDay() === dayOfWeek) {
						count++;
					}
					if (count < n) {
						date.setDate(date.getDate() + 1);
					}
				}
				return date;
			};
			const findLastDay = (year, month, dayOfWeek) => {
				const date = new Date(year, month + 1, 0); // last day of month
				while (date.getDay() !== dayOfWeek) {
					date.setDate(date.getDate() - 1);
				}
				return date;
			};

			const addHoliday = date => {
				const day = date.getDay();
				if (day === 0) {
					// Sunday
					holidays.push(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1));
				} else if (day === 6) {
					// Saturday
					holidays.push(new Date(date.getFullYear(), date.getMonth(), date.getDate() - 1));
				} else {
					holidays.push(date);
				}
			};

			// Fixed holidays
			addHoliday(new Date(year, 0, 1)); // New Year's Day
			addHoliday(new Date(year, 5, 19)); // Juneteenth
			addHoliday(new Date(year, 6, 4)); // Independence Day
			addHoliday(new Date(year, 10, 11)); // Veterans Day
			addHoliday(new Date(year, 11, 25)); // Christmas Day

			// Floating holidays
			holidays.push(findNthDay(year, 0, 1, 3)); // MLK Day
			holidays.push(findNthDay(year, 1, 1, 3)); // Presidents' Day
			holidays.push(findLastDay(year, 4, 1)); // Memorial Day
			holidays.push(findNthDay(year, 8, 1, 1)); // Labor Day
			holidays.push(findNthDay(year, 10, 4, 4)); // Thanksgiving

			return holidays;
		},
	},
	created() {
		//console.log(this.disable_past);
		//if (this.disable_past) this.disableDates = { to: daysAgo(-1) };
		if (this.disable_past) {
			var d = new Date();
			//d.setDate(d.getDate() - 1);
			this.disableDates = { to: d };
		} else if (this.disable_future) {
			var d2 = new Date();
			d2.setDate(d2.getDate() + 1);
			this.disableDates = { from: d2 };
		}

		const year = new Date().getFullYear();
		const holidays = this.getUSHolidays(year);
		const holidaysPrevYear = this.getUSHolidays(year - 1);
		const holidaysNextYear = this.getUSHolidays(year + 1);
		this.highlighted.dates = this.highlighted.dates.concat(holidays, holidaysPrevYear, holidaysNextYear);
		//this.disableDates = { to: new Date(2022, 3, 5), from: new Date(2022, 3, 25) };
	},
};
</script>

<style>
.vdp-datepicker {
	display: inline-block;
}
.vdp-datepicker__calendar {
	white-space: normal;
}
.vdp-datepicker__calendar .cell.day.sat,
.vdp-datepicker__calendar .cell.day.sun,
.vdp-datepicker__calendar .cell.day.highlighted {
	color: red;
	background-color: white;
}
.vdp-datepicker__calendar .cell.day.today {
	color: blue;
}
</style>
